import eases from 'eases';

// Core
import { scrollAnimationProgress } from '~scripts/core/animations';
import { BREAKPOINTS } from '~scripts/core/breakpoints';

// Breakpoints
const mediaSm = window.matchMedia(`(max-width: ${BREAKPOINTS.smMax})`);

// Animation
function apiSuperpowerInit() {
  let apiSuperpowerAnimation = [];

  const handleApiSuperpowerAnimation = () => {
    const apiSuperpowerItems = document.querySelectorAll('.js-api-superpower-item');

    if (mediaSm.matches) {
      apiSuperpowerAnimation.forEach((stop) => stop());
    } else {
      apiSuperpowerAnimation = Array.from(
        apiSuperpowerItems,
        (apiSuperpowerItem) => {
          return scrollAnimationProgress(apiSuperpowerItem, {
            getStart(el) {
              const rect = el.getBoundingClientRect();
              return rect.top + window.scrollY - (window.innerHeight + 100);
            },
            getEnd(el, start) {
              return start + window.innerHeight * 0.66;
            },
            lerpValue: 0.25,
          });
        },
        eases.expoOut
      );
    }
  };

  handleApiSuperpowerAnimation();
  mediaSm.addEventListener('change', handleApiSuperpowerAnimation);
}

export default apiSuperpowerInit;
